<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-edit"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main" *ngIf="isPolicyholder">
                        {{'ASIDE_PARTY.EDIT_POLICYHOLDER' | translate}}
                    </h2>
                    <h2 class="title-main" *ngIf="!isPolicyholder && insured.id !== null">
                        {{'ASIDE_PARTY.EDIT_INSURED' | translate}}
                    </h2>
                    <h2 class="title-main" *ngIf="!isPolicyholder && insured.id === null">
                        {{'ASIDE_PARTY.ADD_INSURED' | translate}}
                    </h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section">

                <div class="section-content" *ngIf="isPolicyholder">
                    <div class="separator"></div>

                    <app-party-form [party]="policyholder.policyholder"
                                    [aside]="true"
                                    prefix="policyholder">
                    </app-party-form>

                    <div class="row form-row" *ngIf="isPolicyholder">
                        <div class="col form-label-static">
                            <mat-checkbox [(ngModel)]="policyholder.policyholderIsInsuredPerson">
                                {{ 'LABEL.INSURER_IS_INSURED' | translate }}
                            </mat-checkbox>

                            <app-errors [errorStateMatcher]="matchers.policyholderIsInsuredPerson"></app-errors>
                        </div>
                    </div>

                </div>

                <div class="section-content" *ngIf="!isPolicyholder">
                    <div class="separator"></div>
                    <app-party-form [party]="insured"
                                    [aside]="true"
                                    prefix="party">
                    </app-party-form>
                </div>
            </div>

            <div class="section-content">
                <app-errors [errorStateMatcher]="matchers.global"></app-errors>
            </div>
        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn">
            <button (click)="close()"
                    class="btn btn-secondary"
                    type="button">
                {{ 'BUTTON.CANCEL' | translate }}
            </button>

            <button (click)="save()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.SAVE' | translate }}
            </button>
        </div>
    </div>
</div>
